import * as React from "react";
import { useLocation } from "wouter";
import { apiFetch } from "@/lib/api.js";

export default function ForgotPasswordPage() {
  const [, navigate] = useLocation();
  const [email, setEmail] = React.useState("");
  const [sent, setSent] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await apiFetch("/api/auth/forgot-password", { method: "POST", body: JSON.stringify({ email }) });
      setSent(true);
    } catch (err: any) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper p-4">
      <div className="w-full max-w-sm bg-card rounded-lg border border-clay-border p-8">
        <h1 className="text-2xl font-semibold text-amethyst-ink mb-1 font-headline tracking-[-0.01em]">Reset Password</h1>
        <p className="text-sm text-faint mb-6">Enter your email to receive a reset link</p>
        {sent ? (
          <>
            <p className="text-sm text-success-text bg-success-wash rounded-md px-3 py-2 mb-4">If an account exists with that email, you'll receive a reset link shortly.</p>
            <button onClick={() => navigate("/")} className="w-full py-2.5 rounded-md bg-primary text-white text-sm font-medium hover:bg-amethyst-ink transition-colors">Back to Sign In</button>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full px-3 py-2.5 rounded-sm border border-clay-border text-sm text-body placeholder:text-faint focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary" />
            {error && <p className="text-[0.8125rem] text-error-text">{error}</p>}
            <button type="submit" disabled={loading} className="w-full py-2.5 rounded-md bg-primary text-white text-sm font-medium hover:bg-amethyst-ink transition-colors disabled:bg-clay-muted disabled:text-body disabled:cursor-not-allowed">
              {loading ? "..." : "Send Reset Link"}
            </button>
          </form>
        )}
        <div className="mt-4 text-center">
          <button onClick={() => navigate("/")} className="text-[0.8125rem] text-primary hover:underline">Back to Sign In</button>
        </div>
      </div>
    </div>
  );
}
